import type { ReactElement } from 'react';
import { RouterProvider } from 'react-router';

import { Providers } from '@/app/providers';
import { router } from '@/app/router';
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';
import { RouteError } from '@/shared/ui/RouteStatus';

export function App(): ReactElement {
  return (
    /* Outermost net. Per-route failures are caught inside the layout so the
       shell survives them; anything that gets this far has taken the shell with
       it, and a reload is the only honest recovery. */
    <ErrorBoundary
      fallback={(error) => (
        <RouteError error={error} reset={() => window.location.reload()} fullPage />
      )}
    >
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  );
}
